import React, { useEffect, useMemo, useRef, useState } from 'react'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import RenderMiniImg from './../Slider/RenderMiniImg'
import GrayButton from './GrayButton'

const BRenderAddPictures = ({
    setPictures,
    pictures,
    maxCount = 5
}) => {
    const ref = useRef(null)
    const [previewArray, setPreviewArray] = useState([])
    const [slideIndex, setSlideIndex] = useState(null)

    useEffect(() => {
        let mounted = true
        const filesArray = Array.isArray(pictures) ? pictures : Array.from(pictures || [])
        const readers = []

        const load = async () => {
            const result = await Promise.all(
                filesArray.map((file) => new Promise((resolve) => {
                    const reader = new FileReader()
                    readers.push(reader)
                    reader.onloadend = () => resolve(reader.result)
                    reader.readAsDataURL(file)
                }))
            )

            if (mounted) {
                setPreviewArray(result.filter(Boolean))
            }
        }

        if (filesArray.length) {
            load()
        } else {
            setPreviewArray([])
        }

        return () => {
            mounted = false
            readers.forEach((reader) => {
                try {
                    if (reader.readyState === 1) {
                        reader.abort()
                    }
                } catch (e) { }
            })
        }
    }, [pictures])

    const itemPreview = useMemo(
        () => previewArray.filter((item) => typeof item === 'string' && item.slice(0, 4) === 'data'),
        [previewArray]
    )

    const handleImageChange = (event) => {
        const incoming = Array.from(event.target.files || []).filter((file) => file.type.startsWith('image/'))
        const limited = incoming.slice(0, maxCount)
        setPictures(limited)
    }

    const clearAllPhoto = () => {
        setPictures([])
        setPreviewArray([])
        if (ref.current) {
            ref.current.value = ''
        }
    }

    return (
        <div className="renderAddPictures">
            <RenderMiniImg
                itemObj={itemPreview}
                slideIndex={slideIndex}
                directlyImg
            />

            <div className="renderAddPictures__buttonBox">
                {!itemPreview.length ? null : (
                    <GrayButton
                        type="miniGrayButton"
                        text="Очистить все"
                        onClick={clearAllPhoto}
                    />
                )}

                <div
                    className="renderAddPictures__button"
                    title="Добавить"
                    onClick={(event) => {
                        event.preventDefault()
                        if (ref.current) {
                            ref.current.click()
                        }
                    }}
                >
                    <AttachFileIcon />
                </div>

                <input
                    type="file"
                    name="realPhotos"
                    onChange={handleImageChange}
                    multiple
                    accept="image/*"
                    ref={ref}
                    style={{ display: 'none' }}
                />
            </div>
        </div>
    )
}

export default BRenderAddPictures